module.exports = __webpack_public_path__ + "img/binding_mb_tab_03.c088818f.png";